import React from 'react';

import NotificationMenu from './NotificationMenu';

export const Notifications = () => <NotificationMenu />;

export default Notifications;
